module.exports = __webpack_public_path__ + "cute.aeb48d45.png";